import React from "react";
import { Link } from "react-router-dom";
// reactstrap components
import {
  Button,
  Collapse,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  UncontrolledTooltip,
} from "reactstrap";
import SolBannerImg from "assets/img/sol institute banner-01.png";

function SolNavbar({ useColor = true }) {
  const [navbarColor, setNavbarColor] = React.useState("navbar-transparent");
  const [collapseOpen, setCollapseOpen] = React.useState(false);
  React.useEffect(() => {
    const updateNavbarColor = () => {
      if (
        document.documentElement.scrollTop > 399 ||
        document.body.scrollTop > 399
      ) {
        setNavbarColor("");
      } else if (
        document.documentElement.scrollTop < 400 ||
        document.body.scrollTop < 400
      ) {
        setNavbarColor("navbar-transparent");
      }
    };
    window.addEventListener("scroll", updateNavbarColor);
    return function cleanup() {
      window.removeEventListener("scroll", updateNavbarColor);
    };
  });
  return (
    <>
      {collapseOpen ? (
        <div
          id='bodyClick'
          onClick={() => {
            document.documentElement.classList.toggle("nav-open");
            setCollapseOpen(false);
          }}
        />
      ) : null}
      <Navbar
        className={!useColor ? "fixed-top " + navbarColor : "fixed-top"}
        expand='xl'
        color='info'
      >
        <Container>
          <div className='navbar-translate'>
            <NavbarBrand href='/' id='navbar-brand'>
              <img
                src={SolBannerImg}
                alt='Sol Institute'
                style={{ height: 35 }}
              />
            </NavbarBrand>
            <button
              className='navbar-toggler navbar-toggler'
              onClick={() => {
                document.documentElement.classList.toggle("nav-open");
                setCollapseOpen(!collapseOpen);
              }}
              aria-expanded={collapseOpen}
              type='button'
            >
              <span className='navbar-toggler-bar top-bar'></span>
              <span className='navbar-toggler-bar middle-bar'></span>
              <span className='navbar-toggler-bar bottom-bar'></span>
            </button>
          </div>
          <Collapse
            className='justify-content-end'
            isOpen={collapseOpen}
            navbar
          >
            <Nav navbar style={{ fontSize: 18 }}>
              <NavItem>
                <NavLink href='/'>
                  <p>Home</p>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink href='/about'>
                  <p>About</p>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink href='/services'>
                  <p>Services</p>
                </NavLink>
              </NavItem>
              {/* <NavItem>
                <NavLink href='/events'>
                  <p>Events</p>
                </NavLink>
              </NavItem> */}
              <NavItem>
                <NavLink href='/contact'>
                  <p>Contact</p>
                </NavLink>
              </NavItem>
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
    </>
  );
}

export default SolNavbar;
